import { NgModule } from '@angular/core';

import { MasterMasterHomeActions } from './master-master-home.actions';

@NgModule({
  providers: [
    MasterMasterHomeActions
  ]
})
export class MasterMasterHomeActionsModule {}
